import React, { useEffect, useRef, useState } from 'react';
import { Engine } from '../intro-engine/Engine';
import bootvox from '../intro-engine/bootvox';

// Boot intro: the exact gb4k.fr V2 engine intro (GB4K in flying voxel cubes on
// a synthwave grid, with bloom + CRT), rendered by the V2 WebGL2 engine so the
// animation matches the V2 one-to-one. Overlaid with a CONNECT button.

interface Props { onConnect: () => void; }

const IntroVisualization: React.FC<Props> = ({ onConnect }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const cv = canvasRef.current;
    if (!cv) return;
    let engine: Engine;
    try {
      engine = new Engine(cv);
    } catch {
      setFailed(true);
      return;
    }
    engine.register('boot', () => Promise.resolve({ default: bootvox }));
    engine.start();
    void engine.setScene('boot');
    return () => { engine.stop(); };
  }, []);

  return (
    <div className="intro-overlay">
      {!failed && <canvas ref={canvasRef} className="intro-canvas" />}
      <button className="intro-connect" onClick={onConnect}>&#9654; CONNECT TO TERMINAL 64 BASIC V2</button>
    </div>
  );
};

export default IntroVisualization;
